var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const u = up.util;
up.HelloFragment = class HelloFragment {
    constructor(root, macros, compilers, { layer, data, dataRoot, dataMap, meta, insertedEvent }) {
        var _a, _b, _c;
        layer || (layer = up.layer.get(root) || up.layer.current);
        this._root = root;
        this._macros = macros;
        this._compilers = compilers;
        this._layer = layer;
        this._data = data;
        this._dataRoot = dataRoot || root;
        this._dataMap = dataMap;
        this._compilePromises = [];
        this._insertedEvent = insertedEvent !== null && insertedEvent !== void 0 ? insertedEvent : true;
        meta || (meta = {});
        (_a = meta.layer) !== null && _a !== void 0 ? _a : (meta.layer = layer);
        (_b = meta.ok) !== null && _b !== void 0 ? _b : (meta.ok = true);
        (_c = meta.revalidating) !== null && _c !== void 0 ? _c : (meta.revalidating = false);
        this._meta = meta;
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            up.puts('up.hello()', "Compiling fragment %o", this._root);
            this._assignDataToElements();
            this._runCompilers(this._macros);
            this._emitCompileEvent();
            this._runCompilers(this._compilers);
            this._emitInsertedEvent();
            yield Promise.all(this._compilePromises);
            return this._root;
        });
    }
    _emitCompileEvent() {
        up.emit(this._root, 'up:compilers:before', { log: false });
    }
    _emitInsertedEvent() {
        if (this._insertedEvent) {
            up.fragment.emitInserted(this._root, this._meta);
        }
    }
    _assignDataToElements() {
        if (this._data) {
            this._dataRoot.upCompileData = this._data;
        }
        if (this._dataMap) {
            for (let selector in this._dataMap) {
                for (let match of this._select(selector)) {
                    match.upCompileData = this._dataMap[selector];
                }
            }
        }
    }
    _runCompilers(compilers) {
        this._layer.asCurrent(() => {
            for (let compiler of compilers) {
                this._runCompiler(compiler);
            }
        });
    }
    _runCompiler(compiler) {
        var _a, _b;
        const matches = this._selectOnce(compiler);
        if (!matches.length) {
            return;
        }
        if (!compiler.isDefault) {
            up.puts('up.hello()', 'Compiling %d× "%s" on %s', matches.length, compiler.selector, this._layer);
        }
        if (compiler.batch) {
            this._compileBatch(compiler, matches);
        }
        else {
            for (let match of matches) {
                this._compileOneElement(compiler, match);
            }
        }
        (_b = (_a = up.migrate).postCompile) === null || _b === void 0 ? void 0 : _b.call(_a, matches, compiler);
    }
    _compileOneElement(compiler, element) {
        const compileArgs = [element];
        if (compiler.length !== 1) {
            const data = up.script.data(element);
            compileArgs.push(data, this._meta);
        }
        let onDestructor = (destructor) => up.destructor(element, destructor);
        this._applyCompilerFunction(compiler, element, compileArgs, onDestructor);
    }
    _compileBatch(compiler, elements) {
        const compileArgs = [elements];
        if (compiler.length !== 1) {
            const dataList = u.map(elements, up.script.data);
            compileArgs.push(dataList, this._meta);
        }
        let onDestructor = () => this._reportBatchCompilerWithDestructor(compiler);
        this._applyCompilerFunction(compiler, elements, compileArgs, onDestructor);
    }
    _applyCompilerFunction(compiler, elementOrElements, compileArgs, onDestructor) {
        return __awaiter(this, void 0, void 0, function* () {
            let maybeDestructor = up.error.guard(() => compiler.apply(elementOrElements, compileArgs));
            if (u.isPromise(maybeDestructor)) {
                let guardedPromise = up.error.guardPromise(maybeDestructor);
                this._compilePromises.push(guardedPromise);
                maybeDestructor = yield guardedPromise;
            }
            if (maybeDestructor)
                onDestructor(maybeDestructor);
        });
    }
    _reportBatchCompilerWithDestructor(compiler) {
        let error = new up.Error(['Batch compiler (%s) cannot return a destructor', compiler.selector]);
        reportError(error);
    }
    _select(selector) {
        return up.fragment.subtree(this._root, u.evalOption(selector), { layer: this._layer });
    }
    _selectOnce(compiler) {
        let matches = this._select(compiler.selector);
        if (!compiler.rerun) {
            matches = u.filter(matches, (element) => {
                let appliedCompilers = (element.upAppliedCompilers || (element.upAppliedCompilers = new Set()));
                if (!appliedCompilers.has(compiler)) {
                    appliedCompilers.add(compiler);
                    return true;
                }
            });
        }
        return matches;
    }
};
